const dev = {
  apiGateway: {
    URL: 'https://olxa283qv9.execute-api.us-east-1.amazonaws.com/dev',
    REGION: 'us-east-1',
  },
  cognito: {
    //USER_POOL_ID : 'us-east-1_j6u3NMthT',
    //APP_CLIENT_ID : '3ppsmb3oq1k2noq4bl2i3cne26',
    USER_POOL_ID : 'us-east-1_Y4D7ulljD',
    APP_CLIENT_ID : '1l6av022ctns72619ts7q03cli',
    REGION: 'us-east-1',
  IDENTITY_POOL_ID: 'us-east-1:5f0805fd-07ba-4e90-938d-cb44e58f7766',
  }
};

const prod = {
  apiGateway: {
    URL: 'https://0j5f8b8tv1.execute-api.us-east-1.amazonaws.com/prod',
    REGION: 'us-east-1',
  },
  cognito: {
    USER_POOL_ID : 'us-east-1_t3v6zqx8T',
    APP_CLIENT_ID : '4ojfr0u31807bhhad57s65hqfj',
    REGION: 'us-east-1',
  IDENTITY_POOL_ID: 'us-east-1:7b4dc940-8b9d-4250-8950-003921bd1edd',
  }
};

const config = process.env.REACT_APP_STAGE === 'production'
  ? prod
  : dev;

export default {
  ...config
};


// WEBPACK FOOTER //
// ./src/config.js